import { render, staticRenderFns } from "./infoForm1.vue?vue&type=template&id=6d5adc5c&scoped=true&"
import script from "./infoForm1.vue?vue&type=script&lang=js&"
export * from "./infoForm1.vue?vue&type=script&lang=js&"
import style0 from "./infoForm1.vue?vue&type=style&index=0&id=6d5adc5c&scoped=true&rel=stylesheet%2Fscss&lang=scss&"
import style1 from "./infoForm1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5adc5c",
  null
  
)

export default component.exports